import { Alert, AlertTitle, Box, Link, Typography } from "@mui/material";

// Onde o cliente resolve pagamento e verificação da conta do WhatsApp Business.
const WHATSAPP_MANAGER_URL = "https://business.facebook.com/wa/manage/";

// Quantos motivos crus da Meta cabem antes de virar parede de texto.
const MAX_MOTIVOS = 3;

/**
 * Banner de saúde da conta na API Oficial.
 *
 * Consome o `accountHealth` que o backend já devolve pronto — o mesmo veredito
 * que o painel principal usa —, então a decisão de "tem problema ou não" mora no
 * servidor e esta tela só desenha.
 *
 * Nasceu de um caso real: a Meta recusava a entrega por falta de método de
 * pagamento e as mensagens paravam em silêncio, sem o cliente ter como
 * descobrir o motivo.
 *
 * Silencioso por contrato: sem problema, não renderiza NADA. Banner vermelho
 * indevido assusta o cliente à toa e queima a credibilidade do aviso.
 */
function AccountHealthBanner({ accountHealth }) {
  if (!accountHealth || !accountHealth.hasIssue) return null;

  const severidade = accountHealth.severity === "warning" ? "warning" : "error";
  const motivos = Array.isArray(accountHealth.reasons) ? accountHealth.reasons : [];

  return (
    <Alert severity={severidade} sx={{ marginTop: 2, marginBottom: 1 }}>
      <AlertTitle sx={{ fontWeight: "bold" }}>{accountHealth.title}</AlertTitle>

      <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
        {accountHealth.message}
      </Typography>

      {motivos.length > 0 && (
        <Box component="ul" sx={{ mt: 1, mb: 0, pl: 2.5 }}>
          {motivos.slice(0, MAX_MOTIVOS).map((motivo, indice) => (
            <Typography
              key={`${motivo.code || "motivo"}-${indice}`}
              component="li"
              variant="caption"
              sx={{ opacity: 0.85 }}
            >
              {motivo.description}
              {motivo.solution ? ` — ${motivo.solution}` : ""}
            </Typography>
          ))}
        </Box>
      )}

      {accountHealth.paymentIssue && (
        <Typography variant="body2" sx={{ mt: 1 }}>
          <Link href={WHATSAPP_MANAGER_URL} target="_blank" rel="noopener noreferrer">
            Abrir o Gerenciador do WhatsApp Business
          </Link>
        </Typography>
      )}
    </Alert>
  );
}

export default AccountHealthBanner;
